import { Component } from "@angular/core";

@Component({
    selector: "adapt-organisations-dashboard-page",
    templateUrl: "./organisations-dashboard-page.component.html",
    standalone: false,
})
export class OrganisationsDashboardPageComponent {

}
